import { LegacyRef, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import Bg from 'assets/img/screenType1/bgsm.png'
import Mn1 from 'assets/img/screenType1/mn11.png'
import Mn2 from 'assets/img/screenType1/mn12.png'
import Mn3 from 'assets/img/screenType1/mn13.png'
import Mn4 from 'assets/img/screenType1/mn14.png'
import Mn5 from 'assets/img/screenType1/mn15.png'

import { selectDevice } from 'hooks/deviceInfo'
import { useSelector } from 'react-redux'

import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import ArrowLeft from 'assets/img/main/arrowLeft.svg'
import ArrowRight from 'assets/img/main/arrowRight.svg'

import { useSpring, animated } from '@react-spring/web'

import { useNavigate } from 'react-router-dom'

const Container = styled.div`
	position: relative;
	width: 1920px;
	height: 1080px;
	background: #000;
	// background-image: url(${Bg});
	// background-size: cover;
	// background-repeat: no-repeat;
	// background-position: center;
`
const MenuList = styled.ul`
	position: absolute;
	top: 201px;
	right: 148px;
	list-style: none;
	padding: 0;
	li {
		position: relative;
		margin-bottom: 25px;
		width: 140px;
		height: 140px;
		overflow: hidden;
		border-radius: 100%;
		.menu {
			transition: all 0.15s ease-in-out;
			&:active {
				transform: scale(0.95);
			}
		}
		img {
			max-width: 100%;
			box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
			border-radius: 100%;
		}
		&:before {
			content: '';
			display: inline-block;
			position: absolute;
			top: -180px;
			left: 0;
			width: 30px;
			height: 100%;
			background: #fff;
			animation: shiny-btn1 2s ease-in-out infinite;
		}
		&:nth-child(1):before {
			animation-delay: 0.05s;
		}
		&:nth-child(2):before {
			animation-delay: 0.1s;
		}
		&:nth-child(3):before {
			animation-delay: 0.15s;
		}
		&:nth-child(4):before {
			animation-delay: 0.2s;
		}
		&:nth-child(5):before {
			animation-delay: 0.25s;
		}
	}
	@keyframes shiny-btn1 {
		0% {
			-webkit-transform: scale(0) rotate(45deg);
			opacity: 0;
		}
		80% {
			-webkit-transform: scale(0) rotate(45deg);
			opacity: 0.2;
		}
		81% {
			-webkit-transform: scale(4) rotate(45deg);
			opacity: 0.4;
		}
		100% {
			-webkit-transform: scale(150) rotate(45deg);
			opacity: 0;
		}
	}
`

const SlideContainer = styled.section`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: transparent;
	overflow: hidden;
	.imgContainer {
		img {
			display: block;
			margin: 0 auto;
			max-width: 100%;
		}
	}
`

const NextArrowContainer = styled.div`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	right: 50px;
	width: 43px;
	height: 85px;
	z-index: 1;
	&::before {
		content: url(${ArrowRight});
		width: 43px;
		height: 85px;
	}
`
const PrevArrowContainer = styled.div`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	left: 50px;
	width: 43px;
	height: 85px;
	z-index: 1;
	&::before {
		content: url(${ArrowLeft});
		width: 43px;
		height: 85px;
	}
`

/**
 * P.PUN 러닝화 선택 화면 (작은 아이콘)
 * @param param0
 * @returns
 */
const ScreenType1Sm = ({ menuList, visualList, prunSmImageList }: any) => {
	const deviceInfo = useSelector(selectDevice)
	const navigate = useNavigate()

	const menuMove1 = useSpring({
		from: { y: 100, opacity: 0 },
		to: { y: 0, opacity: 1 },
		delay: 0,
	})
	const menuMove2 = useSpring({
		from: { y: 100, opacity: 0 },
		to: { y: 0, opacity: 1 },
		delay: 100,
	})
	const menuMove3 = useSpring({
		from: { y: 100, opacity: 0 },
		to: { y: 0, opacity: 1 },
		delay: 200,
	})
	const menuMove4 = useSpring({
		from: { y: 100, opacity: 0 },
		to: { y: 0, opacity: 1 },
		delay: 300,
	})
	const menuMove5 = useSpring({
		from: { y: 100, opacity: 0 },
		to: { y: 0, opacity: 1 },
		delay: 400,
	})

	const menuMove = useSpring({
		from: { y: 100, opacity: 0 },
		to: { y: 0, opacity: 1 },
		delay: 300,
	})
	const [props, api] = useSpring(
		() => ({
			from: { opacity: 0 },
			to: { opacity: 1 },
		}),
		[]
	)

	const NextArrow = (props: any) => {
		const { className, style, onClick } = props
		return (
			<NextArrowContainer
				className={className}
				style={{ ...style }}
				onClick={onClick}
			/>
		)
	}

	const PrevArrow = (props: any) => {
		const { className, style, onClick } = props
		return (
			<PrevArrowContainer
				className={className}
				style={{ ...style }}
				onClick={onClick}
			/>
		)
	}

	const sliderRef = useRef<Slider | null>(null)
	const [currentSlide, setCurrentSlide] = useState<number>(0)
	const videoRef = useRef<HTMLVideoElement>(null)

	const settings = {
		dots: false,
		infinite: true,
		arrows: true,
		speed: 300,
		fade: true,
		slidesToShow: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		nextArrow: <NextArrow />,
		prevArrow: <PrevArrow />,
		beforeChange: (current: number, next: number) => setCurrentSlide(next),
		afterChange: (current: number) => onItemChanged(current),
	}

	const onItemClick = (item: any) => {
		console.log(item)
		switch (item.title) {
			case '쿠션화':
				navigate('/prun/cushion', { state: { item } })
				break
			case '안정화':
				navigate('/prun/protection', { state: { item } })
				break
			case '바운싱화':
				navigate('/prun/bounce', { state: { item } })
				break
			case '레이싱화':
				navigate('/prun/speed', { state: { item } })
				break
			case '트레일러닝화':
				navigate('/prun/trail', { state: { item } })
				break
			default:
				break
		}
	}

	const onItemChanged = (current: number) => {
		// if current slide is video/mp4 then play the video and stop autoplay
		const currentSlide = visualList[current]
		// console.log(currentSlide.fileMime)
		// if (
		//     currentSlide.fileMime === 'video/mp4' ||
		//     currentSlide.fileMime === 'video/quicktime'
		// ) {
		//     sliderRef.current?.slickPause()
		//     const video = videoRef.current
		//     if (video) {
		//         video.src =
		//             `${process.env.REACT_APP_HOST}/video/view/` +
		//             visualList[current]?.fileName
		//         video.load()
		//         video.currentTime = 0
		//         video.play()
		//     }
		// } else {
		//     sliderRef.current?.slickPlay()
		// }
		sliderRef.current?.slickPlay()
	}

	const handleVideoEnded = () => {
		const video = videoRef.current
		if (video) {
			video.pause()
			video.currentTime = 0
		}
		setTimeout(() => {
			sliderRef.current?.slickNext()
		}, 300)
	}

	useEffect(() => {
		console.log(menuList)
		console.log(visualList)
		if (deviceInfo.branchCd && deviceInfo.kioskName) {
		}
		const disablePinchZoom = (e: any) => {
			if (e.touches.length > 1) {
				e.preventDefault()
			}
		}
		// const v = document.getElementById('video_100') as HTMLVideoElement
		// if (v) {
		// 	v.play()
		// }
		console.log('currentSlide', currentSlide)
		document.addEventListener('touchmove', disablePinchZoom, {
			passive: false,
		})
		return () => {
			document.removeEventListener('touchmove', disablePinchZoom)
		}
	}, [currentSlide])

	return (
		<Container>
			<animated.div style={props}>
				<SlideContainer>
					<Slider
						ref={sliderRef}
						{...settings}
					>
						{/* {visualList.map((item: any, index: number) => {
                            return (
                                <div className="imgContainer" key={item.fileId}>
                                    {item.fileMime === 'video/mp4' ||
                                    item.fileMime === 'video/quicktime' ? (
                                        <video
                                            width="100%"
                                            height="100%"
                                            muted
                                            onEnded={handleVideoEnded}
                                            id={'video_' + index}
                                            ref={videoRef}
                                        >
                                            <source
                                                src={
                                                    `${process.env.REACT_APP_HOST}/video/view/${item.fileName}` ||
                                                    ''
                                                }
                                                type={item.fileMime}
                                            />
                                        </video>
                                    ) : (
                                        <img
                                            src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
                                            alt=""
                                            loading="lazy"
                                        />
                                    )}
                                </div>
                            )
                        })} */}
						{prunSmImageList.map((item: any, index: number) => (
							<div
								className="imgContainer"
								key={item.fileId}
							>
								<img
									src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
									alt=""
									loading="lazy"
								/>
							</div>
						))}
					</Slider>
				</SlideContainer>
			</animated.div>
			<div>
				<MenuList>
					{menuList.map((item: any, index: number) => {
						return (
							<li
								key={index}
								onClick={() => onItemClick(item)}
							>
								<img
									src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
									alt={item.title}
									loading="lazy"
								/>
							</li>
						)
					})}
				</MenuList>
			</div>
		</Container>
	)
}

export default ScreenType1Sm
